<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Web App Version List</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
  </div>

  <div class="modal-body">
    <div class="container-fluid p-0">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Tag</th>
            <th>Published At</th>
            <th>Body</th>
            <th>Asset</th>
          </tr>
        </thead>
        <tbody>
          @for (release of releaseList; track release) {
            <tr>
              <td>{{ release.tagName }}</td>
              <td>{{ release.publishedAt | date: "dd-MM-yyyy" }}</td>
              <td>{{ release.body }}</td>
              <td>
                @for (asset of release.assets; track asset) {
                  <button class="btn btn-dark m-1" (click)="pushThisRelease(release.tagName, asset.name)">{{ asset.name }}</button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</form>
